import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';

import * as styles from './FlightBannerDesktop.css';

interface IFlightBannerDesktopProps {
  onClick: () => void;
  onShow: () => void;
  url: string;
}

export const FlightBannerDesktop: React.FC<IFlightBannerDesktopProps> = ({ onClick, onShow, url }) => {
  return (
    <ActionAfterViewObserver callback={onShow} wrapper={false}>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={styles['container']}
        data-testid="FlightBannerDesktop"
        onClick={onClick}
      >
        <ArticleHeading1 color="white_100">12 способов купить квартиру выгодно</ArticleHeading1>
        <ArticleParagraph1 color="white_100">
          Разбираем все варианты, как сэкономить на покупке новостройки
        </ArticleParagraph1>
        <div className={styles['button-wrapper']}>
          {/* TODO: После установки свежей версии кита заменить на кнопку с темой. */}
          <button className={styles['button']}>
            <ArticleParagraph1 fontWeight="bold">Читать статью</ArticleParagraph1>
          </button>
        </div>
      </a>
    </ActionAfterViewObserver>
  );
};
